import dayjs from 'dayjs'

export const formatDate = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
  // const format = 'YYYY-MM-DD dddd HH:mm:ss.SSS A'
  dayjs(date).format(format);
}

export const diffDate = (date1, date2, type = 'day') => {
  let num = dayjs(date1).diff(date2, type)
  return Math.abs(num)
}

